// extracted by mini-css-extract-plugin
export default {"widgetCard":"styles_widgetCard__A6N4g","widgetIcon":"styles_widgetIcon__bGqcH"};